'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.processRegisterDependencies = processRegisterDependencies;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

var _forEach = require('lodash/forEach');

var _forEach2 = _interopRequireDefault(_forEach);

var _omit = require('lodash/omit');

var _omit2 = _interopRequireDefault(_omit);

var _dependencyInjection = require('@aveneo/frontmoon-utils/lib/dependencyInjection');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DiContext = _react2.default.createContext();

function processRegisterDependencies(dependenciesFunctions, di, store) {
    var collectDependencies = function collectDependencies(prevStack, getDependencies) {
        var dependencies = getDependencies(prevStack, store);

        return (dependencies.components || []).reduce(function (stack, pack) {
            return (0, _merge2.default)({}, stack, { components: pack(stack) });
        }, (0, _merge2.default)({}, prevStack, (0, _omit2.default)(dependencies, 'components')));
    };

    var dependiences = dependenciesFunctions.reduce(collectDependencies, {});

    (0, _forEach2.default)(dependiences.modules, function (_ref) {
        var module = _ref.module,
            moduleName = _ref.moduleName;

        (0, _dependencyInjection.registerModule)(_extends({ moduleName: moduleName, di: di, store: store }, module));
    });

    (0, _dependencyInjection.registerDependencies)(di, dependiences.components);
}

exports.default = DiContext;